import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'

export enum AccountState {
  'unconfirmedAccount' = 2,
  'disabledAccount' = 3,
  'blacklistedAccount' = 4,
  'wrongCredentials' = 6,
  'blockedIp' = 7,
  'applicationError' = 11,
  'guidNotFound' = 16,
}

export enum AuthenticationAdditionalActionEnum {
  none = 'None',
  registration = 'Registration',
  mooneyRegistration = 'MooneyRegistration',
}

export enum AccountErrorCodeEnum {
  actionRequired = 'ACTION_REQUIRED',
  userNotFound = 'USER_NOT_FOUND',
  wrongCredentials = 'WRONG_CREDENTIALS',
  userNotConfirmed = 'USER_NOT_CONFIRMED',
  userDisabled = 'USER_DISABLED',
  userClosed = 'USER_WAITING_FOR_CLOSURE',
  userInBlackList = 'USER_IN_BLACKLIST',
  ambiguousCredentials = 'AMBIGUOUS_CREDENTIALS',
  unhandled = 'USER_IN_UNHANDLED_STATUS',
  genericError = 'ERR_GENERIC',
  userDataSynchronisationError = 'MISSING_SYNC',
  unauthorized = 'UNAUTH',
}

export interface BaseLoginOutput extends BaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  Tipo: 'redirect' | 'login'
  GuidAccount: string
  AccountState: AccountState
  AuthenticationAdditionalAction: AuthenticationAdditionalActionEnum
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isBaseLoginOutput = (output: any): output is BaseLoginOutput =>
  isBaseOutput(output) && has(output, 'Tipo') && has(output, 'AccountState')
